import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const Infrastructure = () => {  
  useEffect(() => {
    document.title = 'Infrastructure - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>Infrastructure</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                       <div className="col-lg-12">
                       <div className="accordion sample infra" id="accordionExample">
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingTransport">
                               <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseTransport" aria-expanded="true" aria-controls="collapseTransport">
                                   Transport
                               </button>
                           </h4>
                           <div id="collapseTransport" className="accordion-collapse collapse show"
                               aria-labelledby="headingTransport" data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                      
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="a"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/transport1.jpg">
                                               <img
                                                   src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/transport1.jpg"
                                                   className="img-fluid"/>
                                               </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="a"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/transport2.jpg">
                                               <img
                                                   src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/transport2.jpg"
                                                   className="img-fluid"/>
                                               </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="a"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/transport3.jpg">
                                               <img
                                                   src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/transport3.jpg"
                                                   className="img-fluid"/>
                                               </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="a"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/transport4.jpg">
                                               <img
                                                   src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/transport4.jpg"
                                                   className="img-fluid"/>
                                               </a>
                                       </div>
                       
                                   </div>
                                   
                                   <div className="mt-3 transportsec">
                                       <div className="transportdiv">
                                           <p>School to Agroha</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Uklana Mandi</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Barwala</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Village Ghirai</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Village Rajli</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Village Dhiktana, Bugana, Sulkhani</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Village Mirzapur, Niyana, Danshu</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Kaimri Road, Hisar</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Azad Nagar, Hisar</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to Sector 9-11, Sector 16-17, Hisar</p>
                                       </div>
                                       <div className="transportdiv">
                                           <p>School to All Our City Hisar</p>
                                       </div>
                                   </div>
                                  
                                   <div className="mt-3"/>
                                       <p><strong>Transportation Letter to Parents</strong></p>
                                       <p>
                                           <b>Dear Parent/Guardian:</b><br/>
                                           Please help us ensure your child’s safety by following these simple but important
                                           procedures:<br/>
                                       <ul>
                                           <li>Make sure your child arrives at the designated bus stop five minutes early each
                                               day.</li>
                                           <li>Insist that your child wait for the bus safely in an orderly fashion, back from
                                               the
                                               roadway. Behavior problems at the bus stop can create hazardous conditions for
                                               children.</li>
                                           <li>When the bus arrives, your child should wait for the bus driver’s signal before
                                               boarding.
                                               Children should board in single file. </li>
                                           <li>Teach your child to sit quietly on the ride to and fro from school. Behavior
                                               problems could
                                               distract the bus driver and result in an accident.</li>
                                           <li>It is important that our drivers are able to concentrate on driving the route
                                               safely. If
                                               anything makes your child feel unsafe at the bus stop or on the bus ride, please
                                               contact us
                                               at the transportation department, rather than trying to discuss it at the bus
                                               stop.</li>
                                       </ul>
                                       We are deeply committed to the safety of your child as well as all our community’s
                                       children.<br/>
                                       <b>Transportation Incharge:</b> <br/>
                                       <b>Mr. Sunil</b><br/>
                                       <b>Mob. 9802684000</b>
                                       </p>
                                   </div>
                               </div>
                           </div>
                        
                        <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingBuilding">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseBuilding" aria-expanded="false" aria-controls="collapseBuilding">
                                   Building
                               </button>
                           </h4>
                           <div id="collapseBuilding" className="accordion-collapse collapse" aria-labelledby="headingBuilding"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="building"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/building_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/building_1.jpg"
                                                   className="img-fluid rounded" alt="Building Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="building"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/building_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/building_2.jpg"
                                                   className="img-fluid rounded" alt="Building Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="building"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/building_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/building_3.jpg"
                                                   className="img-fluid rounded" alt="Building Image 3"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="building"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/building_4.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/building_4.jpg"
                                                   className="img-fluid rounded" alt="Building Image 4"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingBasketball">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseBasketball" aria-expanded="false"
                                   aria-controls="collapseBasketball">
                                   Basketball
                               </button>
                           </h4>
                           <div id="collapseBasketball" className="accordion-collapse collapse" aria-labelledby="headingBasketball"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="basketball"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Basketball_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Basketball_1.jpg"
                                                   className="img-fluid rounded" alt="Basketball Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="basketball"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Basketball_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Basketball_2.jpg"
                                                   className="img-fluid rounded" alt="Basketball Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="basketball"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Basketball_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Basketball_3.jpg"
                                                   className="img-fluid rounded" alt="Basketball Image 3"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingBiology">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseBiology" aria-expanded="false" aria-controls="collapseBiology">
                                   Biology Lab
                               </button>
                           </h4>
                           <div id="collapseBiology" className="accordion-collapse collapse" aria-labelledby="headingBiology"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="biology"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Biology_Lab_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Biology_Lab_1.jpg"
                                                   className="img-fluid rounded" alt="Biology Lab Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="biology"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Biology_Lab_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Biology_Lab_2.jpg"
                                                   className="img-fluid rounded" alt="Biology Lab Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="biology"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Biology_Lab_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Biology_Lab_3.jpg"
                                                   className="img-fluid rounded" alt="Biology Lab Image 3"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingChemistry">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseChemistry" aria-expanded="false" aria-controls="collapseChemistry">
                                   Chemistry Lab
                               </button>
                           </h4>
                           <div id="collapseChemistry" className="accordion-collapse collapse" aria-labelledby="headingChemistry"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="chemistry"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_1.jpg"
                                                   className="img-fluid rounded" alt="Chemistry Lab Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="chemistry"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_2.jpg"
                                                   className="img-fluid rounded" alt="Chemistry Lab Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="chemistry"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_3.jpg"
                                                   className="img-fluid rounded" alt="Chemistry Lab Image 3"/>
                                          
                                           </a>
                                       </div>
                       
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="chemistry"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_4.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_4.jpg"
                                                   className="img-fluid rounded" alt="Chemistry Lab Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="chemistry"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_5.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Chemistry_Lab_5.jpg"
                                                   className="img-fluid rounded" alt="Chemistry Lab Image 3"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                        
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingPhysics">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapsePhysics" aria-expanded="false" aria-controls="collapsePhysics">
                                   Physics Lab
                               </button>
                           </h4>
                           <div id="collapsePhysics" className="accordion-collapse collapse" aria-labelledby="headingPhysics"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="physics"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Physics_Lab_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Physics_Lab_1.jpg"
                                                   className="img-fluid rounded" alt="Physics Lab Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="physics"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Physics_Lab_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Physics_Lab_2.jpg"
                                                   className="img-fluid rounded" alt="Physics Lab Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="physics"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Physics_Lab_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Physics_Lab_3.jpg"
                                                   className="img-fluid rounded" alt="Physics Lab Image 3"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="physics"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Physics_Lab_4.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Physics_Lab_4.jpg"
                                                   className="img-fluid rounded" alt="Physics Lab Image 4"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingComputerLab">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseComputerLab" aria-expanded="false"
                                   aria-controls="collapseComputerLab">
                                   Computer Lab
                               </button>
                           </h4>
                           <div id="collapseComputerLab" className="accordion-collapse collapse"
                               aria-labelledby="headingComputerLab" data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-6 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="computer-lab"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Computer_Lab_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Computer_Lab_1.jpg"
                                                   className="img-fluid rounded" alt="Computer Lab Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-6 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="computer-lab"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Computer_Lab_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Computer_Lab_2.jpg"
                                                   className="img-fluid rounded" alt="Computer Lab Image 2"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingLibrary">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseLibrary" aria-expanded="false" aria-controls="collapseLibrary">
                                   Library
                               </button>
                           </h4>
                           <div id="collapseLibrary" className="accordion-collapse collapse" aria-labelledby="headingLibrary"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="library"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_1.jpg"
                                                   className="img-fluid rounded" alt="Library Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="library"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_2.jpg"
                                                   className="img-fluid rounded" alt="Library Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="library"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_3.jpg"
                                                   className="img-fluid rounded" alt="Library Image 3"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="library"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_4.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_4.jpg"
                                                   className="img-fluid rounded" alt="Library Image 4"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="library"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_5.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Library_5.jpg"
                                                   className="img-fluid rounded" alt="Library Image 5"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingMusicRoom">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseMusicRoom" aria-expanded="false" aria-controls="collapseMusicRoom">
                                   Music Room
                               </button>
                           </h4>
                           <div id="collapseMusicRoom" className="accordion-collapse collapse" aria-labelledby="headingMusicRoom"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="music-room"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_1.jpg"
                                                   className="img-fluid rounded" alt="Music Room Image 1"/>
                                          
                                           </a>
                                           
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="music-room"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_2.jpg"
                                                   className="img-fluid rounded" alt="Music Room Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="music-room"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_3.jpg"
                                                   className="img-fluid rounded" alt="Music Room Image 3"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="music-room"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_4.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_4.jpg"
                                                   className="img-fluid rounded" alt="Music Room Image 4"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="music-room"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_5.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Music_Room_5.jpg"
                                                   className="img-fluid rounded" alt="Music Room Image 5"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingDanceRoom">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseDanceRoom" aria-expanded="false" aria-controls="collapseDanceRoom">
                                   Dance Room
                               </button>
                           </h4>
                           <div id="collapseDanceRoom" className="accordion-collapse collapse" aria-labelledby="headingDanceRoom"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-6 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="dance-room"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Dance_room_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Dance_room_1.jpg"
                                                   className="img-fluid rounded" alt="Dance Room Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-6 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="dance-room"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Dance_room_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Dance_room_2.jpg"
                                                   className="img-fluid rounded" alt="Dance Room Image 2"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                        
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingFootballGround">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseFootballGround" aria-expanded="false"
                                   aria-controls="collapseFootballGround">
                                   Football Ground
                               </button>
                           </h4>
                           <div id="collapseFootballGround" className="accordion-collapse collapse"
                               aria-labelledby="headingFootballGround" data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-6 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="football-ground"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Football_Ground_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Football_Ground_1.jpg"
                                                   className="img-fluid rounded" alt="Football Ground Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-6 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="football-ground"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Football_Ground_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Football_Ground_2.jpg"
                                                   className="img-fluid rounded" alt="Football Ground Image 2"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingKarate">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseKarate" aria-expanded="false" aria-controls="collapseKarate">
                                   Karate
                               </button>
                           </h4>
                           <div id="collapseKarate" className="accordion-collapse collapse" aria-labelledby="headingKarate"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="karate"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Karate_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Karate_1.jpg"
                                                   className="img-fluid rounded" alt="Karate Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="karate"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Karate_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Karate_2.jpg"
                                                   className="img-fluid rounded" alt="Karate Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="karate"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Karate_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Karate_3.jpg"
                                                   className="img-fluid rounded" alt="Karate Image 3"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="karate"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Karate_4.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Karate_4.jpg"
                                                   className="img-fluid rounded" alt="Karate Image 4"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingKidsClassroom">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseKidsClassroom" aria-expanded="false"
                                   aria-controls="collapseKidsClassroom">
                                   Kids' Classroom
                               </button>
                           </h4>
                           <div id="collapseKidsClassroom" className="accordion-collapse collapse"
                               aria-labelledby="headingKidsClassroom" data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-6 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="kids-classroom"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kids_Classroom_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kids_Classroom_1.jpg"
                                                   className="img-fluid rounded" alt="Kids' Classroom Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-6 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="kids-classroom"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kids_Classroom_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kids_Classroom_2.jpg"
                                                   className="img-fluid rounded" alt="Kids' Classroom Image 2"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                      
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingKidsPark">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseKidsPark" aria-expanded="false" aria-controls="collapseKidsPark">
                                   Kids' Park
                               </button>
                           </h4>
                           <div id="collapseKidsPark" className="accordion-collapse collapse" aria-labelledby="headingKidsPark"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="kids-park"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kid_Park_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kid_Park_1.jpg"
                                                   className="img-fluid rounded" alt="Kids' Park Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="kids-park"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kid_Park_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kid_Park_2.jpg"
                                                   className="img-fluid rounded" alt="Kids' Park Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="kids-park"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kid_Park_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kid_Park_3.jpg"
                                                   className="img-fluid rounded" alt="Kids' Park Image 3"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-3 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="kids-park"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kid_Park_4.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Kid_Park_4.jpg"
                                                   className="img-fluid rounded" alt="Kids' Park Image 4"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                       
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingBusParking">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseBusParking" aria-expanded="false"
                                   aria-controls="collapseBusParking">
                                   Bus Parking
                               </button>
                           </h4>
                           <div id="collapseBusParking" className="accordion-collapse collapse" aria-labelledby="headingBusParking"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-4 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="bus-parking"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Bus_Parking_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Bus_Parking_1.jpg"
                                                   className="img-fluid rounded" alt="Bus Parking Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-4 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="bus-parking"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Bus_Parking_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Bus_Parking_2.jpg"
                                                   className="img-fluid rounded" alt="Bus Parking Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-4 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="bus-parking"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Bus_Parking_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Bus_Parking_3.jpg"
                                                   className="img-fluid rounded" alt="Bus Parking Image 3"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       
                      
                       <div className="accordion-item panelstyle">
                           <h4 className="accordion-header" id="headingYoga">
                               <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                   data-bs-target="#collapseYoga" aria-expanded="false" aria-controls="collapseYoga">
                                   Yoga
                               </button>
                           </h4>
                           <div id="collapseYoga" className="accordion-collapse collapse" aria-labelledby="headingYoga"
                               data-bs-parent="#accordionExample">
                               <div className="accordion-body">
                                   <div className="row g-4 circular_sec">
                                       <div className="col-md-4 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="yoga"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Yoga_1.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Yoga_1.jpg"
                                                   className="img-fluid rounded" alt="Yoga Image 1"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-4 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="yoga"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Yoga_2.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Yoga_2.jpg"
                                                   className="img-fluid rounded" alt="Yoga Image 2"/>
                                          
                                           </a>
                                       </div>
                                       <div className="col-md-4 fullwidth500">
                                          
                                           <a data-magnify="gallery" data-src="" data-group="yoga"
                                               href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Yoga_3.jpg">
                                               <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/Yoga_3.jpg"
                                                   className="img-fluid rounded" alt="Yoga Image 3"/>
                                          
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       </div>
                       </div>
                    </div> 
                 </div>
           </section>
           <Footer/>
        </>
    );
}

export default Infrastructure;
